import { Directive, inject } from '@angular/core';
import { Select } from 'primeng/select';

/**
 * Applies to every <p-select> (no template changes needed).
 *
 * Sets `filter` and `showClear` to true by default.
 * `filterBy` is not set: PrimeNG falls back to `optionLabel` automatically.
 *
 * To opt out on a specific select, bind the inputs explicitly
 * (template bindings are applied after these defaults and override them):
 *
 *   <p-select [filter]="false" [showClear]="false" ... />
 */
@Directive({
    selector: 'p-select',
    standalone: true,
})
export class SelectDefaultsDirective {
    private readonly select = inject(Select, { self: true });

    constructor() {
        this.select.filter = true;
        this.select.showClear = true;
    }
}